import { LanguageType } from "./types";

export const LanguageNameMap: Record<LanguageType, string> = {
  python: "Python",
  javascript: "JavaScript",
};

export const languages = Object.keys(LanguageNameMap) as LanguageType[];
